import * as tslib_1 from "tslib";
import { Exclude, Expose } from 'class-transformer';
import { BaseEntity } from '../../_helpers';
var UserEntity = /** @class */ (function (_super) {
    tslib_1.__extends(UserEntity, _super);
    function UserEntity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    tslib_1.__decorate([
        Expose(),
        tslib_1.__metadata("design:type", String)
    ], UserEntity.prototype, "username", void 0);
    UserEntity = tslib_1.__decorate([
        Exclude()
    ], UserEntity);
    return UserEntity;
}(BaseEntity));
export { UserEntity };
